export const STORAGE_TOKENS = 'exportafacil_auth_token';
export const STORAGE_PERMISSIONS = 'permisos_exportafacil';
export const STORAGE_USER = 'user_exportafacil';
export const DEFAULT_ERROR_MESSAGE = 'Ocurrió un error. Por favor inténtelo nuevamente más tarde.';
export const CALENDAR_TYPE_MONTH = 'month';
export const CALENDAR_TYPE_DAY = 'day';
export const CALENDAR_TYPE_WEEK = 'week';
export const SNACKS_DEFAULT_MILLIS = 5000;
export const ROL_ADMIN = 'Admin';
export const ROL_DINACOPA_OPERACIONES = 'DINACOPA Operaciones';
export const ROL_DINACOPA_ADMISION = 'DINACOPA Admisión';
export const ROL_DINACOPA_LOGISTICA = 'DINACOPA Logística';
export const ROL_VUE = 'VUE';
export const ESTADO_BORRADOR = 1;
